import { LOCATION_CHANGED, LocationChangedAction } from 'redux-little-router';
import { StateObservable } from 'redux-observable';
import { Observable, OperatorFunction } from 'rxjs';
import { audit, filter } from 'rxjs/operators';

import { Action } from '../actions';
import { RoutesPath } from '../routes/index';
import { State } from '../typings/state';

export const awaitCommonData = (
    action$: Observable<Action>,
    store$: StateObservable<State>
): OperatorFunction<Action, Action> => {
    return audit(() => {
        return store$.pipe(filter(state => state.commonData.dataFetched));
    });
};

export const ofRoute = (...routes: RoutesPath[]): OperatorFunction<Action, Action> => {
    return filter((action: Action) => {
        if (action.type !== LOCATION_CHANGED) {
            return false;
        }
        return routes.includes(action.payload.route);
    });
};

export const ofNewVisit = (
    store$: StateObservable<State>
): OperatorFunction<LocationChangedAction, LocationChangedAction> => {
    return filter((action: LocationChangedAction) => {
        const { route } = action.payload;
        const { previous } = store$.value.router;
        return route !== (previous && previous.route);
    });
};
